import type { FieldPath, FieldValues, UseFormReturn } from 'react-hook-form';

export const clearFieldErrorsByType = <TFieldValues extends FieldValues>(
  form: UseFormReturn<TFieldValues>,
  fieldNames: ReadonlyArray<FieldPath<TFieldValues>>,
  errorTypes?: readonly string[]
) => {
  fieldNames.forEach(fieldName => {
    const fieldErrorType = form.getFieldState(fieldName).error?.type;

    if (!fieldErrorType) {
      return;
    }

    if (errorTypes && !errorTypes.includes(fieldErrorType)) {
      return;
    }

    form.clearErrors(fieldName);
  });
};
